import { getVimeoIdFromUrl } from "./getVimeoIdFromUrl"

export const generateVimeoUrl = (url: string): string => {
  const videoId = getVimeoIdFromUrl(url)
  if (!videoId) return ""

  return `https://player.vimeo.com/video/${videoId}?&autoplay=0&loop=1&title=0&byline=0&portrait=0&muted=1&#t=0s`
}
